var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLivebottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104px",
    height: "38px",
    viewBox: "0 0 104 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDE9Bicon/truck/livebottom2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-29",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    x: 1,
    y: 31,
    width: 70,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,9 L71,19.1817821 L50.872073,31 L23.2892409,31 L1,19.1532888 L1,9 L71,9 Z",
    id: "Rectangle-Copy-21",
    stroke: "#4F7CB4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.646923,9 L99,19.3531095 L99,31 L77,31 L77,9 L90.646923,9 Z",
    id: "Combined-Shape",
    stroke: "#4F7CB4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-29",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    fill: "#FFFFFF",
    cx: 22,
    cy: 33,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-31",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    fill: "#FFFFFF",
    cx: 8,
    cy: 33,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-25",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    fill: "#FFFFFF",
    cx: 92,
    cy: 33,
    r: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-38",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    transform: "translate(62.000000, 17.000000) rotate(-270.000000) translate(-62.000000, -17.000000) ",
    x: 56,
    y: 17,
    width: 12,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-39",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    transform: "translate(10.000000, 17.000000) rotate(-270.000000) translate(-10.000000, -17.000000) ",
    x: 4,
    y: 17,
    width: 12,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-40",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    transform: "translate(21.000000, 19.500000) rotate(-270.000000) translate(-21.000000, -19.500000) ",
    x: 12.5,
    y: 19.5,
    width: 17,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-41",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    transform: "translate(51.000000, 20.000000) rotate(-270.000000) translate(-51.000000, -20.000000) ",
    x: 42,
    y: 20,
    width: 18,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-42",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    transform: "translate(36.000000, 20.000000) rotate(-270.000000) translate(-36.000000, -20.000000) ",
    x: 27,
    y: 20,
    width: 18,
    height: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivebottom);
export default __webpack_public_path__ + "static/media/livebottom.7e3048303242b51f5c09c335558b10ce.svg";
export { ForwardRef as ReactComponent };